import React from 'react';
import PropTypes from 'prop-types';
import './VideoUploadConfirmDialog.css';

/**
 * Asks the user whether to upload a freshly picked video file to
 * bpmn.weissenberg-group.de (so the <video> element can read it
 * without CORS) or to keep it as a local-only blob.
 */
const VideoUploadConfirmDialog = ({ isOpen, fileName, fileSize, onUpload, onUseLocal, onCancel }) => {
  if (!isOpen) return null;

  const sizeMb = fileSize ? (fileSize / (1024 * 1024)).toFixed(1) : null;

  return (
    <div className="video-upload-dialog-overlay">
      <button
        type="button"
        className="video-upload-dialog-overlay-btn"
        onClick={onCancel}
        aria-label="Dialog schließen"
      />
      <dialog className="video-upload-dialog" open aria-label="Video hochladen?">
        <div className="video-upload-dialog-header">
          <span className="video-upload-icon">
            <i className="bi bi-cloud-upload-fill"></i>
          </span>
          <h5>Video hochladen?</h5>
        </div>
        <div className="video-upload-dialog-body">
          <p>
            Soll <strong>{fileName || 'das Video'}</strong>
            {sizeMb ? <> (<span>{sizeMb}&nbsp;MB</span>)</> : null} auf{' '}
            <code>bpmn.weissenberg-group.de</code> gespeichert werden?
          </p>
          <div className="video-upload-info">
            <i className="bi bi-info-circle"></i>
            <div>
              <strong>Vorteile beim Hochladen:</strong>
              <ul>
                <li>Keine CORS-Einschränkungen → Screenshots funktionieren</li>
                <li>Video bleibt nach Neuladen der Seite verfügbar</li>
                <li>Andere Personen mit Zugriff sehen dasselbe Video</li>
              </ul>
              <strong>Nur lokal verwenden:</strong>
              <ul>
                <li>Kein Upload — Datei verlässt deinen Rechner nicht</li>
                <li>Nach Schließen des Tabs ist das Video weg</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="video-upload-dialog-footer">
          <button className="btn video-upload-btn-confirm" onClick={onUpload}>
            <i className="bi bi-cloud-upload"></i> Hochladen
          </button>
          <button className="btn video-upload-btn-local" onClick={onUseLocal}>
            <i className="bi bi-hdd"></i> Nur lokal
          </button>
          <button className="btn video-upload-btn-cancel" onClick={onCancel}>
            Abbrechen
          </button>
        </div>
      </dialog>
    </div>
  );
};

VideoUploadConfirmDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  fileName: PropTypes.string,
  fileSize: PropTypes.number,
  onUpload: PropTypes.func.isRequired,
  onUseLocal: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default VideoUploadConfirmDialog;
